import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { initialDebugState } from '@/types/DebugState';
import { refreshDiagnosticsThunk } from '@/store/thunks/debug/refreshDiagnosticsThunk';
import { refreshLogsThunk } from '@/store/thunks/debug/refreshLogsThunk';
import { setLogPatternThunk } from '@/store/thunks/debug/setLogPatternThunk';
import { setLogLevelThunk } from '@/store/thunks/debug/setLogLevelThunk';
import { clearLogsThunk } from '@/store/thunks/debug/clearLogsThunk';
import { refreshP2PDiagnosticsThunk } from '@/store/thunks/debug/refreshP2PDiagnosticsThunk';

export const debugSlice = createSlice({
  name: 'debug',
  initialState: initialDebugState,
  reducers: {
    openDebugPanel: (state) => {
      state.isOpen = true;
    },
    closeDebugPanel: (state) => {
      state.isOpen = false;
    },
    toggleDebugPanel: (state) => {
      state.isOpen = !state.isOpen;
    },
    setDebugPanelHeight: (state, action: PayloadAction<number>) => {
      state.heightPx = action.payload;
    },
    resetDebugState: () => initialDebugState,
  },
  extraReducers: (builder) => {
    builder.addCase(refreshDiagnosticsThunk.fulfilled, (state, action) => {
      state.storageEstimate = action.payload.storageEstimate;
      state.browserInfo = action.payload.browserInfo;
      state.lastRefreshedAt = action.payload.lastRefreshedAt;
    });
    builder.addCase(refreshLogsThunk.fulfilled, (state, action) => {
      state.logEntries = action.payload.logEntries;
      state.logNamespaces = action.payload.logNamespaces;
      state.logLevel = action.payload.logLevel;
    });
    builder.addCase(setLogPatternThunk.fulfilled, (state, action) => {
      state.logNamespaces = action.payload;
    });
    builder.addCase(setLogLevelThunk.fulfilled, (state, action) => {
      state.logLevel = action.payload;
    });
    builder.addCase(clearLogsThunk.fulfilled, (state) => {
      state.logEntries = [];
    });
    builder.addCase(refreshP2PDiagnosticsThunk.fulfilled, (state, action) => {
      state.p2pDiagnostics = action.payload;
    });
  },
});

export const {
  openDebugPanel,
  closeDebugPanel,
  toggleDebugPanel,
  setDebugPanelHeight,
  resetDebugState,
} = debugSlice.actions;

export default debugSlice.reducer;
